import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

import classes from "./Dashboard.module.scss";

import DashSidebar from "./DashSidebar/DashSidebar";
import Topbar from "./Topbar/Topbar";
import Mainboard from "./Mainboard/Mainboard";

const Dashboard = () => {
  return (
    <>
      <div className={classes.mainwrapper}>
        <Topbar />

        <div className={classes.wrapper}>
          <div>
            <DashSidebar />
          </div>
          <div
            style={{
              width: "-webkit-fill-available",
              overflowY: "scroll",
              borderRadius: "10px 0 0 0",
              background:'white'
            }}
            className={classes.MainBoard}
          >
            <Mainboard>
              <Outlet />
            </Mainboard>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
